module.exports = __webpack_public_path__ + "img/header_dsk.f246717.jpg";